export default __webpack_public_path__ + "media/images/react_icons/bookmark-2159c6cf1c57097cf2a67cf4791fb7d0.svg";